// extracted by mini-css-extract-plugin
export default {"container":"CardCarousel_container__Wh80S","carousel":"CardCarousel_carousel__E6KJk","slide":"CardCarousel_slide__loV1c"};